import { colors } from 'ui/theme/colors';

export const getBorderColor = (checked: boolean, disabled: boolean) => {
  if (disabled) return colors.grey35;
  if (!checked) return colors.borderStrong;
  return colors.backgroundSuccess;
};

export const getBackgroundColor = (checked: boolean, disabled: boolean) => {
  if (disabled) {
    return !checked ? colors.backgroundDisabled : colors.backgroundDisabledStrong;
  }
  if (!checked) return colors.backgroundPrimary;
  return colors.backgroundSuccess;
};

export const getOutlineColor = (disabled: boolean) => {
  if (disabled) return 'none';
  return colors.borderOnColor;
};

export const getBoxShadowColor = (checked: boolean, disabled: boolean) => {
  if (disabled) return 'none';
  if (!checked) return colors.backgroundDisabledStrong;
  return colors.backgroundSuccess;
};
